import Immutable from 'immutable';

import ClassFactory from 'sharedreact/utils/ClassFactory';

const Content: {
  type: string | null,
  code: string | null,
  code2: string | null,
  symbolType: string | null,
  barWidthReduction: number,
  deviceCompensation: number,
  ratio: number,
  narrowBar: number,
  magnification: number,
  resolution: number
} = {
  type: null,
  code: null,
  code2: null,
  symbolType: null,
  barWidthReduction: -1,
  deviceCompensation: -1,
  ratio: -1,
  narrowBar: -1,
  magnification: -1,
  resolution: -1
};

class FileInfoBarcode extends Immutable.Record(Content) {
}

export default FileInfoBarcode;
